import axios from 'axios';
import HeaderManagerHandler from './headerManagerHandler';

const headerManager = (addNotification, setOverQuota, setOverWorkspaceQuota) => {
  axios.interceptors.request.use((config) => HeaderManagerHandler.addAuthorization(config));
  axios.interceptors.response.use(
    (response) => HeaderManagerHandler.manageSuccessRequests(response, addNotification),
    (error) => HeaderManagerHandler.logoutOnForbiddenError(
      error,
      addNotification,
      setOverQuota,
      setOverWorkspaceQuota,
    ),
  );
};

export default headerManager;
